import styled from "styled-components/macro";

export const Inner = styled.div``;
